import type { Mesh, MeshPhysicalMaterial, Object3D } from '@anov/3d-core'
import { LoaderModule } from '@anov/3d-core'
import { SOURCE_BASE_PATH } from '../../../business/Utils/constant'

const load = new LoaderModule()
export enum EMaterialType {
  Plaster = 'Plaster', // 涂料
  Wood = 'Wood', // 木质材质
  Water = 'Water', // 水材质
  Glass = 'Glass', // 玻璃材质
  Iron = 'Iron', // 金属材质
  Moss = 'Moss', // 苔藓材质
  Emissive = 'Emissive', // 发光材质（适用于夜晚窗户）
  Dirt = 'Dirt', // 土壤
  Fabric = 'Fabric', // 布料
  Floor = 'Floor', // 地板
  Marble = 'Marble', // 石材
  Metal = 'Metal', // 金属
  Road = 'Road', // 道路
  Snow = 'snow', // 雪地
  Leather = 'leather', // 皮革
}

const SOURCE_PATH = {
  Plaster: `${SOURCE_BASE_PATH}/material/plaster.glb`, // 涂料
  Wood: `${SOURCE_BASE_PATH}/material/wood.glb`, // 木质材质
  Water: `${SOURCE_BASE_PATH}/material/water.glb`, // 水材质
  Glass: `${SOURCE_BASE_PATH}/material/glass.glb`, // 玻璃材质
  Iron: `${SOURCE_BASE_PATH}/material/iron.glb`, // 金属材质
  Moss: `${SOURCE_BASE_PATH}/material/moss.glb`, // 苔藓材质
  Dirt: `${SOURCE_BASE_PATH}/material/dirt.glb`, // 土壤
  Fabric: `${SOURCE_BASE_PATH}/material/fabric.glb`, // 布料
  Floor: `${SOURCE_BASE_PATH}/material/floor.glb`, // 地板
  Marble: `${SOURCE_BASE_PATH}/material/marble.glb`, // 石材
  Metal: `${SOURCE_BASE_PATH}/material/metal.glb`, // 金属
  Road: `${SOURCE_BASE_PATH}/material/road.glb`, // 道路
  Leather: `${SOURCE_BASE_PATH}/material/leather.glb`, // 皮革
  Snow: `${SOURCE_BASE_PATH}/material/snow.glb`, // 雪地
  Emissive: `${SOURCE_BASE_PATH}/material/emissive.glb`, // 发光材质（适用于夜晚窗户）
  Fresnel_Transparent: `${SOURCE_BASE_PATH}/material/emissive2.glb`,
}

export class SurfaceMaterial {
  private static cache = new Map<string, MeshPhysicalMaterial>()

  static async getMaterial(id: string) {
    id = this.capitalizeFirstLetter(id)
    if (this.cache.has(id))
      return this.cache.get(id).clone()!

    try {
      const material = await this.loadModelMaterial(id)
      this.cache.set(id, material)
      return material.clone()
    }
    catch (error) {
      console.error(`Failed to load material ${id}:`, error)
      throw error
    }
  }

  static async getMaterialAll() {
    const materials = await Promise.all(Object.keys(SOURCE_PATH).map(async key => await this.getMaterial(key)))
    return materials
  }

  static async loadModelMaterial(id: string): Promise<MeshPhysicalMaterial> {
    const uri = SOURCE_PATH[id]
    if (!uri)
      throw new Error(`Invalid material ID: ${id}`)

    const model = await new Promise<Object3D>((resolve, reject) => {
      load.loadGLTF({
        url: uri,
        draco: true,
        onLoad: gltf => resolve(gltf.scene.clone(true)),
        onError: err => reject(err),
      })
    })

    let mesh: Mesh | null = null
    model.traverse((child) => {
      if (!mesh && child.type === 'Mesh')
        mesh = child as Mesh
    })
    if (!mesh?.material)
      throw new Error(`No valid material found in ${id}`)

    return mesh.material as MeshPhysicalMaterial
  }

  static capitalizeFirstLetter(str) {
    if (!str)
      return ''
    return str.charAt(0).toUpperCase() + str.slice(1)
  }
}
